import { type FC, type ReactNode } from "react";
import { Box, Modal, Grid } from "@mui/material";
import { SxProps } from '@mui/material/styles';
import ModalWrapperStyles from "./ModalWrapper.styles";
import CloseIcon from "assets/images/Close.svg";


type ModalWrapperProps = {
  children: ReactNode;
  closeButton?: boolean;
  closeOnBackdropClick?: boolean;
  isOpen: boolean;
  modalContainerSx?: SxProps;
  onClickOutsideModal?: () => void;
  onClose?: () => void;
  sx?: SxProps;
};

const ModalWrapper: FC<ModalWrapperProps> = ({
  children,
  closeButton = false,
  closeOnBackdropClick = true,
  isOpen,
  modalContainerSx = {},
  onClickOutsideModal,
  onClose,
  sx = {}
}) => {
  const classes = ModalWrapperStyles();
  const handleClose = (event: Event, reason = "") => {
    const isBackdropClick = !!(reason && reason === "backdropClick");

    if (isBackdropClick) {
      onClickOutsideModal?.();

      // Does not close the modal on a backdrop click if the closeOnBackdropClick prop is false
      if (!closeOnBackdropClick) {
        return;
      }
    }

    onClose?.();
  };

  return (
    <Modal
      id="modal-message"
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="title-modal"
      aria-describedby="simple-modal-description"
      className={`${classes.modal} fade`}
      closeAfterTransition
      sx={sx}
    >
      <Box sx={{ position: "relative", outline: 0, }}>
        {closeButton && (
          <Box
            alt="Close modal"
            component="img"
            onClick={() => onClose?.()}
            src={CloseIcon}
            sx={{
              cursor: "pointer",
              position: "absolute",
              right: {
                xs: 0,
                lg: "-20px"
              },
              top: "-20px",
              zIndex: 9999
            }}
          />
        )}
        <Grid
          item
          xs={11}
          sm={8}
          md={6}
          lg={4}
          className={classes.modalContainer}
          sx={modalContainerSx}
        >
          <Grid container alignItems="center" justifyContent="center">
            {children}
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default ModalWrapper;